export const getQueryString = (name: string): string | boolean => {
  const url = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const newUrl = window.location.search.substr(1).match(url);
  if (newUrl != null) {
    return unescape(newUrl[2]);
  } else {
    return false;
  }
};
/**
 * 判断字符是否为空
 * @param value
 * @returns {boolean}
 */
export const isEmpty = (value: unknown): boolean => {
  return value === undefined ||
    value === null ||
    value === "" ||
    value === "null";
};

/**
 * 判断字符是否不为空
 * @param value
 * @returns {boolean}
 */
export const isNotEmpty = (value: unknown): boolean => {
  return !isEmpty(value);
};

// 判断是否为微信内置浏览器
export const isWeiXin = (): boolean => {
  try {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") !== -1;
  } catch (e) {
    return false;
  }
};

/**
 * 获取指定长度随机字符串
 * @param len
 */
export const randomStr = (len: number): string => {
  let result = '';
  const dict = 'abcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < len; i++) {
    result += dict.charAt(Math.floor(Math.random() * dict.length));
  }
  return result;
}

/**
 * 合并对象
 * @param obj
 * @param options
 * @returns {*}
 */
export const merge = (obj: Record<string, unknown>, options: Record<string, unknown>) => {
  if (obj && options) {
    for (const p in options) {
      if (typeof obj[p] === "object" && typeof options[p] === "object") {
        merge(obj[p] as Record<string, unknown>, options[p] as Record<string, unknown>);
      } else {
        obj[p] = options[p];
      }
    }
  }
  return obj;
};
